@if (errors.length < 1) {
  <span>
    <a (click)="logout()">
      <mat-icon class="mat-18 mat-icon-color" matTooltip="Sair">{{mdIcon}}</mat-icon>
    </a>
  </span>
}

@if (errors.length > 0) {
  <span>
    @for (error of errors; track error) {
      <mat-error>{{error.cod}} - {{error.message}}</mat-error>
    }
  </span>
}
